import Box from '@mui/material/Box';
import { TitleWithSubtitle } from './atoms/TitleWithSubtitle';
import { BackButton } from './atoms/BackButton';
import { ConfigurationType } from '../types';
import { InitialsAvatar } from '../../shared/InitialsAvatar';
import { useDependencies } from '../hooks/useDependencies';
import { ActionOption, ButtonWithActionMenu } from './atoms/ButtonWithActionMenu';
import { Panel } from './atoms/Panel';
import { MiddlePanel } from './atoms/MiddlePanel';
import { ConfigurationItem } from '../DependenciesTypes';
import { DependenciesSearchInput } from '../search/DependenciesSearchInput';
import { useFeatureToggle } from '../../../../feature-flags/useFeatureToggle';
import Stack from '@mui/material/Stack';
import { DependenciesSearchEntryIcon } from '../search/DependenciesSearchEntryIcon';

interface DependenciesHeaderProps {
  configurationItem: ConfigurationItem;
  type: ConfigurationType;
  crmOrgId: string;
  historyLength?: number;
  isReadOnly?: boolean;
}

export const DependenciesHeader = ({
  configurationItem,
  type,
  crmOrgId,
  historyLength,
  isReadOnly = false,
}: DependenciesHeaderProps) => {
  const { searchInDocumentationCard } = useFeatureToggle();
  const { onGoBackInHistory } = useDependencies(crmOrgId);
  const { annotations } = configurationItem ?? {};
  const { changedBy, changedAt } = annotations ?? {};

  return (
    <Panel sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 0 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        gap={1}
        alignItems="center"
        width="100%"
      >
        {historyLength && historyLength > 1 && <BackButton onClick={onGoBackInHistory} />}

        <Box
          flex={1}
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          width="100%"
        >
          <TitleWithSubtitle
            configurationItem={configurationItem}
            crmOrgId={crmOrgId}
            parentType={type}
          />

          <MiddlePanel>
            {searchInDocumentationCard && <DependenciesSearchEntryIcon />}
            {changedBy && <InitialsAvatar changedAt={changedAt} userIdOrName={changedBy} />}
            <ButtonWithActionMenu
              configurationItem={configurationItem}
              crmOrgId={crmOrgId}
              options={[
                ActionOption.openInSalesforce,
                ActionOption.viewSource,
                ...(!isReadOnly && type !== ConfigurationType.objects
                  ? [ActionOption.comments]
                  : []),
              ]}
            />
          </MiddlePanel>
        </Box>
      </Stack>
      {searchInDocumentationCard && <DependenciesSearchInput />}
    </Panel>
  );
};
